import { Dictionary } from 'src/app/shared/types/dictionary';

/**
 * Base properties all request and responses must contain
 */
export interface BaseProperties {
	/**
	 * The request wanting to be made.
	 */
	request_type: string;

	/**
	 * The backend session ID used for tracking requests from the same user. This is used for debugging purposes.
	 */
	session_id?: string;
}

/**
 * The different type of `status` values
 */
export enum ApiStatus {
	FAILED = 'FAILED',
	PENDING = 'PENDING',
	OK = 'OK',
}

/**
 * The base properties a response may have.
 */
export interface ApiServiceResponse extends Dictionary<any>, BaseProperties {
	/**
	 * The status of the response.
	 */
	status: ApiStatus;

	/* tslint:disable */
	/**
	 * The error code from the API
	 */
	error_code?: string;

	/**
	 * The actual human readable error message
	 */
	error_msg?: string;

	/**
	 * The http status code
	 */
	http_response_code?: string;
	/* tslint:disable */
}

/**
 * Helper interface for declaring a response
 */
export interface ApiResponse<T> {
	/**
	 * The actual service response
	 */
	SERVICE: ApiServiceResponse & T;
}

/**
 * The class for creating an API request using POST
 */
export class ApiRequest {
	/**
	 * Holds the actual service request
	 */
	SERVICE: Dictionary<any>;

	/**
	 * @param requestType The request type you'll be making
	 * @param params The properties to append to the SERVICE node
	 */
	constructor(requestType: string, params: Dictionary<any>) {
		this.SERVICE = {
			...params,
			request_type: requestType,
		};
	}
}
